


























import Vue from 'vue'
export default Vue.extend({
  props: {
    colors: { type: Array },
    geojson: { type: Object },
    element: { type: String, default: '' },
    barShow: { type: Boolean, default: '' },
    flag: { type: Number, default: '' },
  },
  computed: {
    convertPreData() {
      if (!this.colors || !this.geojson) {
        return []
      }
      const geojson: any = this.geojson
      const colorJson: any = this.colors.slice(1, this.colors.length)
      const features = geojson.features
      const min = Math.min(...features.map((e: any) => e.properties.lvalue))
      const max = Math.max(...features.map((e: any) => e.properties.hvalue))
      let minIndex = 0
      let maxIndex = 0
      for (let i = 0; i < colorJson.length; i++) {
        const item = colorJson[i]
        if (item[0] <= min && item[1] > min) {
          minIndex = i
        }
        if (item[0] <= max && item[1] > max) {
          maxIndex = i
        }
        if (250 <= min) {
          minIndex = 5
          maxIndex = 5
        }
      }
      if (minIndex > maxIndex) {
        return
      }
      if (maxIndex < colorJson.length - 1) {
        maxIndex += 1
      }
      if (minIndex > 1) {
        minIndex -= 1
      }
      if (maxIndex < 5) {
        maxIndex = maxIndex - 1
      }
      if (minIndex === 0) {
        minIndex = 0
      }
      const newArray = []
      for (let n = maxIndex; n >= minIndex; n--) {
        const item = colorJson[n]
        let maxs = '0'
        if (item[1] === 100000) {
          maxs = '+∞'
        } else {
          maxs = String(item[1] - 0.1)
        }
        newArray.push({ min: item[0], max: maxs, color: 'rgba(' + item[2] + ',' + item[3] + ',' + item[4] + ')' })
      }
      return newArray
    },
    convertTemData() {
      if (!this.colors || !this.geojson) {
        return []
      }
      const geojson: any = this.geojson
      const colorJson: any = this.colors
      const features = geojson.features
      const min = Math.min(...features.map((e: any) => e.properties.lvalue))
      const max = Math.max(...features.map((e: any) => e.properties.hvalue))
      let minIndex = 0
      let maxIndex = 0
      const colorSize = colorJson.length
      for (let i = 0; i < colorSize; i++) {
        const item = colorJson[i]
        if (item[0] <= min && item[1] > min) {
          minIndex = i
        }
        if (item[0] <= max && item[1] > max) {
          maxIndex = i
        }
        if (50 <= min) {
          minIndex = 49
          maxIndex = 49
        }
        if (50 <= max) {
          maxIndex = 49
        }
      }
      if (minIndex > maxIndex) {
        return
      }
      if (maxIndex < colorSize - 1) {
        maxIndex += 1
      }
      if (minIndex > 0) {
        minIndex -= 1
      }
      const newArray = []
      for (let n = maxIndex; n >= minIndex; n--) {
        const item = colorJson[n]
        newArray.push({ min: item[0], color: 'rgba(' + item[2] + ',' + item[3] + ',' + item[4] + ')' })
      }
      // console.log(newArray)
      return newArray
    },
  },
})
